import { type ReactElement } from 'react'
import { type ConversationResolveLocationFlagged, type LocationId, type WorkflowData } from '@terros/common'
import { type RecordingLocationWarning, useTranslation } from '@front/model'
import { TAlert } from '@components'
import { ServerFlagWarning } from './ServerFlagWarning'

type Props = {
  warnings: RecordingLocationWarning[]
  rejection?: ConversationResolveLocationFlagged
  locationId?: LocationId
  workflows: WorkflowData[]
}

export function ReviewLocationWarnings({ warnings, rejection, locationId, workflows }: Props): ReactElement {
  const { t } = useTranslation()
  return (
    <>
      {warnings.map((warning) => (
        <TAlert key={warning.accountId} variant='warning'>
          {t('{{account}} is in {{stage}}, a stage that flags recordings. Choose another location.', {
            account: warning.accountName,
            stage: warning.stageName,
          })}
        </TAlert>
      ))}
      {rejection?.matches
        .filter((match) => match.locationId === locationId)
        .map((match) => (
          <ServerFlagWarning
            key={match.accountId}
            accountId={match.accountId}
            stageName={
              workflows.flatMap((workflow) => workflow.stages).find((stage) => stage.stageId === match.workflowStageId)
                ?.name ?? match.workflowStageId
            }
          />
        ))}
    </>
  )
}
